







































































































import Vue from 'vue';
import { Data as ArticleData, Headlines, ContentFragment as ArticleContentFragment } from '@root/modules/article/types/article';
import ContentRecipe from '@core/components/UI/ContentRecipe.vue';
import ContentFragment from '@core/components/ContentFragment.vue';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';
import ArticleBodyBottom from '@root/views/article/components/ArticleBodyBottom.vue';
import ArticleRelatedHeadlinesList from '@root/views/article/components/headlines/ArticleRelatedHeadlinesList.vue';
import ArticleHeadlinesSectionAlternative from '@root/views/article/components/headlines/alternative/ArticleHeadlinesSection.vue';

import BodySkeletonLoader from '@root/views/article/components/BodySkeletonLoader.vue';
const ArticlePaywall = () => import(/* webpackChunkName: "ArticlePaywall" */ '@root/views/article/components/paywall/ArticlePaywall.vue');
const CustomerStateHandler = () => import(/* webpackChunkName: "CustomerStateHandler" */ '@root/common/components/helpers/CustomerStateHandler.vue');
import getBannerKey from '@root/modules/ads/utils/getBannerKey';

interface Props {
  article: ArticleData;
  headlines: Headlines | [];
  isArticleFetching: boolean;
  fontSizeClass: string;
}

interface Computed {
  articleGroupedBody: ArticleData['content']['groupedBody'];
  disabledAdsList: string[];
  disableAds: boolean;
  adPlacements: Record<string, any>;
  bodyFirstAd: Record<string, any>;
  isCrArticle: boolean;
  crIndex: number | null;
}

interface Data {
  initFragmentsGroup: FragmentsGroup;
  relatedArticlesSettings: {
    minParagraphsLength: number;
    afterParagraphPosition: number;
    articlesLimit: number;
    articlesInBodyLimit: number;
    endOfArticleBody: boolean;
  };
}

interface Methods {
  getPlacement: (index: number, type: string) => string;
  getKey: (params: Record<string, any>) => string;
}

type Fragment = ArticleContentFragment;

interface FragmentsGroup {
  items: (Fragment | string)[];
  options: {
    skipAds: boolean;
    addRelatedHeadlines: boolean;
    relatedPosition: number;
  };
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    AdFormBanner,
    ArticleBodyBottom,
    ContentFragment,
    ContentRecipe,
    ArticleRelatedHeadlinesList,
    ArticleHeadlinesSectionAlternative,
    ArticlePaywall,
    BodySkeletonLoader,
    CustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    headlines: {
      type: Array,
      required: true,
    },
    isArticleFetching: {
      type: Boolean,
      required: false,
      default: false,
    },
    fontSizeClass: {
      type: String,
      required: false,
      default: 'C-article__body-fs-1',
    },
  },
  data() {
    return {
      initFragmentsGroup: {
        items: [],
        options: {
          skipAds: false,
          addRelatedHeadlines: false,
          relatedPosition: 1,
        },
      },
      relatedArticlesSettings: this.$channelConfig('page').article.component.relatedArticles,
    };
  },
  computed: {
    disabledAdsList() {
      return this.$store.getters['adForm/getDisabledAdsList'];
    },
    disableAds() {
      return this.article.banners.disableAds;
    },
    articleGroupedBody() {
      return this.article.content.groupedBody;
    },
    adPlacements() {
      const placements: Record<string, any> = this.$store.getters['adForm/getAdsPlacements'];

      return placements || {};
    },
    bodyFirstAd() {
      const placements: Record<string, any> = { desktop: null, mobile: null };

      if (this.adPlacements.bodyfirst && this.adPlacements.bodyfirst.mid.length && this.adPlacements.bodyfirst.mid[0]) {
        placements.desktop = this.adPlacements.bodyfirst.mid[0];
      }

      if (this.adPlacements.mobilebodyfirst && this.adPlacements.mobilebodyfirst.mid.length && this.adPlacements.mobilebodyfirst.mid[0]) {
        placements.mobile = this.adPlacements.mobilebodyfirst.mid[0];
      }

      return placements;
    },
    isCrArticle() {
      const articles = this.$store.getters['article/getCrArticles'];

      return articles.find((article: number) => article === this.article.id);
    },
    crIndex() {
      if (this.isCrArticle) {
        const id = this.article.id;
        const crArticles = this.$store.state.article.crArticles;
        return crArticles.indexOf(id) + 1;
      }

      return null;
    },
  },
  methods: {
    getPlacement(index, type) {
      const length = this.articleGroupedBody.length;
      const placements = this.adPlacements[type].mid;
      const loop = Math.ceil(placements.length / length);
      let placement = placements[index];
      let newIndex = null;

      // Loop again through placements
      if (index >= placements.length) {
        newIndex = index - placements.length * loop;
        placement = placements[newIndex];
      }

      return placement;
    },
    getKey({ prefix, index }) {
      return getBannerKey({ prefix, route: this.$route, store: this.$store, index });
    },
  },
});
